<div #elementoAlvo class="section-galery-videos">
  <div class="container">
    <div class="row">
      <div class="content-video">
        <div class="cabecalho">
          <h2  *ngIf="tituloVideo" class="text-center mb-5"><strong>{{ tituloVideo }}</strong></h2>
          <div class="col-lg-6 col-md-6 titulo">
            <h1  *ngIf="!tituloVideo" style="margin-left: 10px" class="text-black">
              Assista aos nossos tutoriais
            </h1>
          </div>
        </div>

        <div class="cont">
          <div class="main-video">
            <div class="video">
              <video
                main-video
                controlsList="nodownload"
                src="{{ env.origin }}/midias/{{ videoPrincipal }}"
                poster="assets/img/{{ capa }}"
                type="video/mp4"
                width="700"
                height=""
                controls
              ></video>
              <h3 class="title">
                {{
                  defaultCategory
                    ? titleVideoPrincipal
                    : 'Conheça a azulzinha, a maquininha da CAIXA'
                }}
              </h3>
            </div>
          </div>
          <div>
            <div class="row mb-3 pt-2">
              <div class="col-12" *ngIf="!defaultCategory">
                <select
                  [disabled]="defaultCategory"
                  (change)="filterVideos($event)"
                  class="form-select"
                  aria-label="Default select example"
                >
                  <option selected disabled value="null">
                    {{
                      defaultCategory
                        ? defaultCategory
                        : 'Selecione uma categoria'
                    }}
                  </option>
                  <option value="all">Todos</option>
                  <option
                    *ngFor="let category of categories; let key = index"
                    value="{{ category.value }}"
                  >
                    {{ category.title }}
                  </option>
                </select>
              </div>
              <!-- <div class="col-6">
                    <input type="email" class="form-control" id="" placeholder="Digite uma categoria">
                </div> -->
            </div>
            <div class="video-list">
              <div
                *ngFor="let video of videos; let key = index"
                (click)="
                  changeVideoAndSendGTM({ element: video, clicou: 'clicou' })
                "
                class="vid active"
                [ngClass]="{
                  active: video.ativo
                }"
              >
                <video
                  controlsList="nodownload"
                  src="{{ env.origin }}/midias/{{ video.src }}"
                  poster="assets/img/{{ video.capa }}"
                  type="video/mp4"
                  width="160"
                  height="100"
                  muted
                ></video>
                <h3 class="title">{{ video.titulo }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
